import { Banknote, Users, Wallet } from 'lucide-react'
import type { BalanceHistoryType } from '@/types/payment'
import type { ProfileTab } from '@/types/profile'

export const PROFILE_TABS: { id: ProfileTab; label: string; icon: typeof Wallet }[] = [
	{ id: 'balances', label: 'Balances', icon: Wallet },
	{ id: 'referral', label: 'Referral', icon: Users },
	{ id: 'transactions', label: 'Transactions', icon: Banknote },
]

export const WALLET_PROVIDERS = [
	{
		id: 'metamask',
		name: 'MetaMask',
		iconUrl: 'https://cdn.jsdelivr.net/gh/glincker/thesvg@main/public/icons/metamask/default.svg',
	},
	{
		id: 'phantom',
		name: 'Phantom',
		iconUrl:
			'https://mintcdn.com/phantom-e50e2e68/tU9g5MXFXgx4l6Em/resources/images/Phantom_SVG_Icon.svg?fit=max&auto=format&n=tU9g5MXFXgx4l6Em&q=85&s=7170eec10d9199f7766d6e4ccd1e56ff',
	},
	{
		id: 'walletconnect',
		name: 'Wallet Connect',
		iconUrl: 'https://cdn.jsdelivr.net/gh/glincker/thesvg@main/public/icons/walletconnect/default.svg',
	},
] as const

export const PROFILE_TRANSACTIONS_PER_PAGE = 15

export const BALANCE_HISTORY_TYPE_LABELS: Record<BalanceHistoryType, string> = {
	deposit_nowpayments: 'Deposit',
	withdrawal_nowpayments: 'Withdrawal',
	deposit_metamask: 'Deposit',
	withdrawal_metamask: 'Withdrawal',
	deposit_solana: 'Deposit',
	withdrawal_solana: 'Withdrawal',
	deposit_admin: 'Admin Deposit',
	withdrawal_admin: 'Admin Withdrawal',
	cancel_withdrawal: 'Withdrawal Cancelled',
	casino_bet: 'Casino Bet',
	casino_commit: 'Casino Commit',
	casino_win: 'Casino Win',
	casino_refund: 'Casino Refund',
	casino_rollback: 'Casino Rollback',
	sportsbook_bet: 'Sportsbook Bet',
	sportsbook_win: 'Sportsbook Win',
	sportsbook_settle: 'Sportsbook Settlement',
	p2p_buy: 'P2P Buy',
	p2p_resolve: 'P2P Resolve',
	game_bet: 'Game Bet',
	game_win: 'Game Win',
	cpa: 'CPA Reward',
	commission: 'Commission',
}
